export default [
    {name: 'users', roles: ['ROLE_ADMIN_USERS']},
    {name: 'offers', roles: ['ROLE_ADMIN_USERS']},
    {name: 'posts', roles: ['ROLE_ADMIN_POSTS']},
    {name: 'divider', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_POSTS']},
    {name: 'packs', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_QUESTIONS']},
    {name: 'questions', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_QUESTIONS']},
    {name: 'answers', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_QUESTIONS']},
    {name: 'answer_groups', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_QUESTIONS']},
    {name: 'conditions', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_QUESTIONS']},
    {name: 'user_answers', roles: ['ROLE_ADMIN_USERS']},
    {name: 'divider', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_QUESTIONS']},
    {name: 'themes', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_QUESTIONS', 'ROLE_ADMIN_TAGS']},
    {name: 'visions', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_QUESTIONS', 'ROLE_ADMIN_TAGS']},
    {name: 'notions', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_QUESTIONS', 'ROLE_ADMIN_TAGS']},
    {name: 'tags', roles: ['ROLE_ADMIN_USERS', 'ROLE_ADMIN_QUESTIONS', 'ROLE_ADMIN_TAGS']},
];



// WEBPACK FOOTER //
// ./src/security/resourceMenu.js